import { EventNotificationsStrategy } from './event-notifications.interface';
import {
  CategoryRenamedNotification,
  CommunityMemberRemovedNotification,
  DoctorPatientLinkAcceptedNotification,
  DoctorPatientLinkRejectedNotification,
  DoctorPatientLinkRemovedNotification,
  DoctorRoleRemovedNotification,
  FileSharedEventNotification,
  InvitationToJoinCommunityAcceptedNotification,
  InvitationToJoinCommunityNotification,
  InvitationToJoinCommunityRejectedNotification,
  InviteToProjectAccepted,
  InviteToProjectDecline,
  LeadGetCommentReplyNotification,
  MemberLeftCommunityNotification,
  PatientRoleRemovedNotification,
  PostCommentedNotification,
  RequestToJoinCommunityApprovedNotification,
  RequestToJoinCommunityDeclinedNotification,
  RequestToJoinCommunityNotification,
  UserGetCommentReplyNotification,
  UserGetConnectionInvitationAcceptsNotification,
  UserGetConnectionInvitationNotification,
  UserGetDoctorPatientLinkInvitation,
  UserGetProjectInvitationNotification,
  UserGetProjectMemberExcludedNotification,
  UserGetProjectMemberLeftNotification,
  UserGetRequestToJoinProject,
  UserGetRequestToProjectAcccepted,
  UserGetRequestToProjectAccceptedByAnyOwner,
  UserGetRequestToProjectDecline,
  UserGetRequestToProjectDeclinedByAnyOwner,
  UserUpdatedReactivationPetition,
} from './event-notifications.strategy';

export const STRATEGY_KEYS: { [key: string]: string } = {
  user_get_connection_invitation: 'com.dntl.1l2c.user_get_connection_invitation',
  invite_to_project: 'com.dntl.1l2c.invite_to_project',
  request_to_join_project: 'com.dntl.1l2c.request_to_join_project',
  user_updated_reactivation_petition: 'com.dntl.1l2c.user_updated_reactivation_petition',
  request_to_project_accepted: 'com.dntl.1l2c.request_to_project_accepted',
  request_to_project_decline: 'com.dntl.1l2c.request_to_project_decline',
  request_to_project_accepted_by_any_owner: 'com.dntl.1l2c.request_to_project_accepted_by_any_owner',
  request_to_project_decline_by_any_owner: 'com.dntl.1l2c.request_to_project_decline_by_any_owner',
  user_connection_invitation_accepts: 'com.dntl.1l2c.user_connection_invitation_accepts',
  invite_to_project_accepted: 'com.dntl.1l2c.invite_to_project_accepted',
  project_member_left: 'com.dntl.1l2c.project_member_left',
  project_member_excluded: 'com.dntl.1l2c.project_member_excluded',
  comment_reply: 'com.dntl.1l2c.comment_reply',
  post_lead_commented: 'com.dntl.1l2c.post_lead_commented',
  doctor_patient_link_added: 'com.dntl.1l2c.doctor_patient_link_added',
  doctor_patient_link_accepted: 'com.dntl.1l2c.doctor_patient_link_accepted',
  doctor_patient_link_rejected: 'com.dntl.1l2c.doctor_patient_link_rejected',
  doctor_patient_link_removed: 'com.dntl.1l2c.doctor_patient_link_removed',
  patient_role_removed: 'com.dntl.1l2c.patient_role_removed',
  doctor_role_removed: 'com.dntl.1l2c.doctor_role_removed',
};

export const STRATEGY_TYPES: { [key: string]: EventNotificationsStrategy } = {
  'com.dntl.1l2c.user_get_connection_invitation': new UserGetConnectionInvitationNotification(),
  'com.dntl.1l2c.user_connection_invitation_accepts': new UserGetConnectionInvitationAcceptsNotification(),
  'com.dntl.1l2c.invite_to_project': new UserGetProjectInvitationNotification(),
  'com.dntl.1l2c.invite_to_project_accepted': new InviteToProjectAccepted(),
  'com.dntl.1l2c.user_updated_reactivation_petition': new UserUpdatedReactivationPetition(),
  'com.dntl.1l2c.invite_to_project_decline': new InviteToProjectDecline(),
  'com.dntl.1l2c.request_to_join_project': new UserGetRequestToJoinProject(),
  'com.dntl.1l2c.request_to_project_accepted': new UserGetRequestToProjectAcccepted(),
  'com.dntl.1l2c.request_to_project_decline': new UserGetRequestToProjectDecline(),
  'com.dntl.1l2c.request_to_project_accepted_by_any_owner': new UserGetRequestToProjectAccceptedByAnyOwner(),
  'com.dntl.1l2c.request_to_project_decline_by_any_owner': new UserGetRequestToProjectDeclinedByAnyOwner(),
  'com.dntl.1l2c.project_member_left': new UserGetProjectMemberLeftNotification(),
  'com.dntl.1l2c.project_member_excluded': new UserGetProjectMemberExcludedNotification(),
  'com.dntl.1l2c.file_shared_notification': new FileSharedEventNotification(),
  'com.dntl.1l2c.invite_to_community': new InvitationToJoinCommunityNotification(),
  'com.dntl.1l2c.invitation_to_join_community_accepted': new InvitationToJoinCommunityAcceptedNotification(),
  'com.dntl.1l2c.invitation_to_join_community_declined': new InvitationToJoinCommunityRejectedNotification(),
  'com.dntl.1l2c.community_member_removed': new CommunityMemberRemovedNotification(),
  'com.dntl.1l2c.member_left_community': new MemberLeftCommunityNotification(),
  'com.dntl.1l2c.request_to_join_community': new RequestToJoinCommunityNotification(),
  'com.dntl.1l2c.request_to_join_community_approved': new RequestToJoinCommunityApprovedNotification(),
  'com.dntl.1l2c.request_to_join_community_declined': new RequestToJoinCommunityDeclinedNotification(),
  'com.dntl.1l2c.post_commented': new PostCommentedNotification(),
  'com.dntl.1l2c.comment_reply': new UserGetCommentReplyNotification(),
  'com.dntl.1l2c.post_lead_commented': new LeadGetCommentReplyNotification(),
  'com.dntl.1l2c.doctor_patient_link_added': new UserGetDoctorPatientLinkInvitation(),
  'com.dntl.1l2c.doctor_patient_link_accepted': new DoctorPatientLinkAcceptedNotification(),
  'com.dntl.1l2c.doctor_patient_link_rejected': new DoctorPatientLinkRejectedNotification(),
  'com.dntl.1l2c.doctor_patient_link_removed': new DoctorPatientLinkRemovedNotification(),
  'com.dntl.1l2c.patient_role_removed': new PatientRoleRemovedNotification(),
  'com.dntl.1l2c.doctor_role_removed': new DoctorRoleRemovedNotification(),
  'com.dntl.1l2c.category_renamed_notification': new CategoryRenamedNotification(),
};
